import { render } from "./FormReport.vue?vue&type=template&id=79acd3a0"
import script from "./FormReport.vue?vue&type=script&lang=js"
export * from "./FormReport.vue?vue&type=script&lang=js"
script.render = render

export default script